export class AuthRequiredError extends Error {
  constructor(public endpointId: string) {
    super(`Authentication required for endpoint: ${endpointId}`);
    this.name = "AuthRequiredError";
  }
}

export class SessionExpiredError extends Error {
  constructor(public endpointId: string) {
    super(`Session expired for endpoint: ${endpointId}`);
    this.name = "SessionExpiredError";
  }
}
